import { RefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

const EventCategoryFacet = () => {
  const dict = useSearchDictionary();

  return (
    <div className={classnames('mb-4')}>
      <div className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>{dict.eventCategory}</div>
      <RefinementList attribute="eventCategory" sortBy={['name:asc']} />
    </div>
  );
};

export default EventCategoryFacet;
